import styled from "@emotion/styled";
import {ReactNode} from "react";

type Props = {
    children?: ReactNode;
}

const Container = styled.div`
    background-color: var(--gray-lightest);
    border-top: 2px solid var(--gray-lighter);
    font-weight: 400;
    white-space: nowrap;
    text-align: left;
    line-height: 1.25;
    vertical-align: middle;
    color: var(--gray-darkest);
    padding: 7px 12px;
    font-size: 1.6rem;
    min-height: 34px;
    
    display: flex;
    justify-content: space-between;

`

export const DataGridToolbar = ({children}: Props) => {
    return <Container>
        {children}
    </Container>
}